import BankAccountApplicationForm from '@/components/bankAccountApplications/form/BankAccountApplicationForm';
import DefaultLayout from '@/components/layouts/DefaultLayout';
import { ROUTES } from '@/constants/routes';
import { useGetUser } from '@/hooks/requests/useUser';
import { useAuthUser } from '@/hooks/stores/useAuthUser';
import { BankApplicationAccountType } from '@/types/bankApplications';
import { useSearchParams } from 'react-router-dom';

export default function BankAccountApplicationPage() {
  const { isStaff } = useAuthUser();
  const { user } = useGetUser();
  const [searchParams] = useSearchParams();
  const customerId = searchParams.get('customerId');
  const businessId = searchParams.get('businessId');
  const companyId = searchParams.get('companyId');
  const advisorId =
    searchParams.get('advisorId') || !isStaff ? user?.teammateInfo?.uuid : '';

  return (
    <DefaultLayout
      header="New Bank Account Application"
      breadcrumb={[
        {
          label: 'Bank Account Applications - Draft',
          href: ROUTES.BANK_ACCOUNT_APPLICATIONS_DRAFT,
        },
        { label: 'New Bank Account Application', isActive: true },
      ]}>
      <BankAccountApplicationForm
        defaultValues={{
          applicationId: '',
          accountType: businessId
            ? BankApplicationAccountType.BUSINESS
            : BankApplicationAccountType.INDIVIDUAL,
          companyId: companyId
            ? companyId
            : isStaff
              ? ''
              : user?.teammateInfo?.company.uuid || '',
          advisorId: advisorId || '',
          individualOwnerId: customerId || '',
          jointOwnerIds: [],
          businessId: businessId || '',
          primaryOwner: customerId || '',
          beneficiaries: [],
          externalAccountDepositId: '',
          depositAmount: '',
          verified: false,
          verifiedExternalAccount: false,
        }}
      />
    </DefaultLayout>
  );
}
